import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { getMySubscriptionApi } from "../../apis/subscriptionApi";

export const useMySubscription = () => {
  const [subscription, setSubscription] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchSubscription = async () => {
    setLoading(true);
    setError(null);

    try {
      const data = await getMySubscriptionApi();
      setSubscription(data);
    } catch (err) {
      setError(err);
      toast.error("Failed to load current subscription.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSubscription();
  }, []);

  return { subscription, loading, error, refetch: fetchSubscription };
};